// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__p4F7l","title":"style__title__lulKY","description":"style__description__ttGJw","component":"style__component__hZMYT"};